export const authHeader = () => {
  const userId = localStorage.getItem('userId');
  return userId ? { 'X-User-Id': userId } : {};
};
